var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterAlt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.56491 15.4808C6.29996 15.4808 6.07788 15.3912 5.89865 15.2119C5.71943 15.0327 5.62981 14.8106 5.62981 14.5457V8.93513L0.206271 2.01544C-0.0275027 1.70374 -0.0625687 1.37646 0.101073 1.03359C0.264714 0.690721 0.549138 0.519287 0.954345 0.519287H14.0457C14.4509 0.519287 14.7353 0.690721 14.8989 1.03359C15.0626 1.37646 15.0275 1.70374 14.7937 2.01544L9.37019 8.93513V14.5457C9.37019 14.8106 9.28057 15.0327 9.10135 15.2119C8.92212 15.3912 8.70004 15.4808 8.43509 15.4808H6.56491ZM7.5 8.28056L12.1287 2.38947H2.87129L7.5 8.28056Z",
    fill: "#B2B1B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterAlt);
export default __webpack_public_path__ + "static/media/filter_alt.1a7ba8f27034a774288e1b270e3b13cc.svg";
export { ForwardRef as ReactComponent };